import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-import-from-machine',
  templateUrl: './import-from-machine.component.html',
  styleUrls: ['./import-from-machine.component.css']
})
export class ImportFromMachineComponent implements OnInit {
  title = "Import From Machine";

  formimport:any={};
  imppthd:any;
  imppthopt:any={};
  bckpthd: any;
  bckopt: any={};
  agntd:any;
  agtopt:any={};
  ag:any=[];
  today = new Date();  
  DateValues:string;
  FeasibilityPDFUrl: any;
  fileToUpload: File = null;

  constructor(private service:UserService,private datePipe:DatePipe) { }

  ngOnInit() 
  {
    debugger;
    //this.FeasibilityFileInput("D:/ghf/yt.pdf")
   this.importpathpig();
   this.backuppathdet();
   this.agentsel();
  this.formimport.exp_dt= this.getdatefun(this.today);
  this.formimport.trnsfr_dt=this.getdatefun(this.today);
  }
 
  importpathpig()
  {
    this.imppthd=this.service.pigmyimppath();
    this.imppthd.subscribe(
      (pthres:any)=>{
        this.imppthopt=pthres;
        console.log(pthres);
        this.formimport.readpath=pthres.STAT;
      }
    )
  }
  backuppathdet()
  {
    this.bckpthd=this.service.pigmybackuppath();
    this.bckpthd.subscribe(
      (bckres:any)=>{
        this.bckopt=bckres;
        console.log(bckres);
        this.formimport.bckpath=bckres.STAT;
      }
    )
  }
  agentsel()
  {
    this.agntd=this.service.selectagent();
    this.agntd.subscribe(
      (agres:any)=>{
        this.agtopt=agres;
        console.log(this.agtopt);
      }
    )
  }
  changeagnt(rec:any,ag:any)
  {
    debugger
    this.AGENT_IDempty=false;
    var chcking=ag[rec-1];
    console.log(chcking.AGENT_DESC);
    this.formimport.agntname=rec;
  }
  getdatefun(indt:any)
  {
    this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
 }

 FeasibilityFileInput(file: FileList) {
   
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.txt|.dat|.PDF)$/;

 
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.FeasibilityPDFUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.service.uploadImages(data);
    x.subscribe(
      (response) => {
        // console.log(response);
        // this.app.APP_PA_PhotoErrorMessage="";

      }, (error) => {
        let i: any = document.getElementById('PD_Feasibility_Report');
        i.value = "";
        if (error.status == 400) {
          this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('PD_Feasibility_Report');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getFeasibilityPDFUrl() {
  let imagename = null;
  try {
    imagename = document.getElementById('PD_Feasibility_Report');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

AGENT_IDempty:boolean=false;

 onSubmit(agent_id:number)
 {
debugger;
if(agent_id==undefined||null)
{
  this.AGENT_IDempty=true;
  swal('Agent','Select a agent to continue','warning');
}
document.getElementById('loader-spinner').style.display = "block";
this.bckpthd=this.service.importpigmydata(agent_id).subscribe(res=>{ 
  this.resetForm(this.formimport);
  document.getElementById('loader-spinner').style.display = "none";
  swal("Import Done","Success","success");
 }
 , (error) => {
  document.getElementById('loader-spinner').style.display = "none";
  swal('Warning!', 'Something went wrong', 'warning');
});
 

 }


 resetForm(form?:NgForm)
 {
  if(form!=null)
  {
    this.formimport.agntselct=null;
    this.formimport.agntname='';
    this.formimport.exp_dt='';
    this.formimport.trnsfr_dt='';

  }
 }


}



// WEBPACK FOOTER //
// ./src/app/general-transaction/import-from-machine/import-from-machine.component.ts